// TypesPrestationsContent.js
import {
  Input,
  Row,
  Col,
  Card,
  Typography,
  Space,
  Button,
  Form,
  Table as AntTable,
  Popconfirm,
  notification,
  Select,
} from "antd";
import { DeleteFilled, ExportOutlined, SyncOutlined, SearchOutlined } from "@ant-design/icons";
import "../Pages/CSS/DonnesBases.css";
import "../Pages/CSS/Traitement.css";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import moment from "moment";
//import { articlesAchatService } from '../Services/articlesAchatService';
import { ArticlesAchatService } from "../Services/ArticlesAchatService";
import { PlanComptaService } from "../Services/PlanComptaService";
const { Title } = Typography;
// Applique size="small" à tous les tableaux de cette page sans autre changement
const Table = ({ size = "small", ...props }) => <AntTable size={size} {...props} />;

const ArticlesAchat = () => {
  const initialTableData = []; // Stocke les données initiales du tableau
  const initialNewPrestation = {
    code_art: "",
    designation_article: "",
    compte_rattache: "",
    prix_unitaire: 0, // Initialiser le prix à zéro
  };

  const [tableData, setTableData] = useState(initialTableData);
  const [filteredData, setFilteredData] = useState(initialTableData); // Utilise initialTableData pour initialiser filteredData
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [planCompta, setPlanCompta] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(true);
  const [newPrestation, setNewPrestation] = useState(initialNewPrestation);

  const articlesAchatService = new ArticlesAchatService();
  const planComptaService = new PlanComptaService();

  useEffect(() => {
    if (planCompta.length === 0) {
      planComptaService
        .getAllPlanCompta()
        .then((data) => {
          setPlanCompta(data);
        })
        .catch((error) => {
          console.error("Erreur lors du chargement des prestations :", error);
        });
    }
  }, [ ]);

  useEffect(() => {
    setLoading(true);
    articlesAchatService
      .getAllArticlesAchat() // Ajoutez les parenthèses pour appeler la fonction
      .then((data) => {
        setTableData(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  const handleUpdate = async () => {
    try {
      if (selectedRowData) {
        await articlesAchatService.updateArticlesAchat(selectedRowData); // Utilise updatePrestation pour mettre à jour la prestation sélectionnée
        const updatedData = await articlesAchatService.getAllArticlesAchat();
        setTableData(updatedData);
        setSelectedRowData(null);
        notification.success({
          message: "Modification réussie",
          description: "La prestation a été modifié avec succès.",
        });
      }
    } catch (error) {
      notification.error({
        message: "erreur",
        description: "Erreur lors de la suppression de la prestation",
      });
    }
  };
  useEffect(() => {
    setFilteredData(tableData); // Initialisation des données filtrées avec les données complètes au chargement
  }, [tableData]);

  const createPrestation = async () => {
    try {
      // Utilisation du numéro de compte sélectionné dans newPrestation.compte_rattache
      newPrestation.compte_rattache =
        newPrestation.compte_rattache.split(" - ")[0];

      await articlesAchatService.addArticlesAchat(newPrestation); // Utilisation de newPrestation pour ajouter la nouvelle prestation
      // Après l'ajout avec succès, rafraîchissez les données
      const updatedData = await articlesAchatService.getAllArticlesAchat();
      setTableData(updatedData);
      notification.success({
        message: "Ajout réussie",
        description: "La prestation a été ajouté avec succès.",
      });
      setShowCreateForm(false); // Masquer le formulaire après l'ajout
    } catch (error) {
      notification.error({
        message: "erreur",
        description: "Erreur lors de la suppression de la prestation",
      });
    }
  };
  // Ensuite, dans votre fonction handleSave, appelez la fonction createPrestation :
  const handleSave = () => {
    createPrestation();
    // Réinitialiser l'état ou effectuer d'autres actions si nécessaire
  };

  const handleDelete = async (code_art) => {
    try {
      await articlesAchatService.deleteArticlesAchat(code_art);
      // Suppression réussie, mettre à jour les données et notifier
      const updatedData = await articlesAchatService.getAllArticlesAchat();
      setTableData(updatedData);
      setSelectedRowData(null);
      notification.success({
        message: "Suppression réussie",
        description: "La prestation a été supprimée avec succès.",
      });
    } catch (error) {
      // Gérer les erreurs côté frontend
      console.error("Erreur lors de la suppression de la prestation :", error);
      notification.error({
        message: "Erreur",
        description: "Erreur lors de la suppression de la prestation.",
      });
    }
  };

  const handleRowClick = (record) => {
    setSelectedRowData(record); // Mettre à jour les données de la ligne sélectionnée
    setShowCreateForm(false);
  };

  const handleNew = () => {
    setSelectedRowData(null); // Réinitialiser les données sélectionnées
    setShowCreateForm(true); // Afficher le formulaire de création lors du clic sur "Nouveau"
  };

  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Met à jour les données filtrées
  };

  const handleResetAll = async () => {
    try {
      const updatedData = await articlesAchatService.getAllArticlesAchat(); // Récupère les nouvelles données
      setTableData(updatedData); // Met à jour le tableau avec les nouvelles données
      setSelectedRowData(null); // Réinitialise les données sélectionnées
    } catch (error) {}
  };

  const handleExport = () => {
    const exportData = tableData.map((item) => ({
      Code: item.code_art,
      Libellé: item.designation_article,
      Compte: item.compte_rattache,
      Prix_Unitaire : item.prix_unitaire,
      "Créer le": item.datecreation
        ? moment(item.datecreation).format("DD-MM-YYYY")
        : "", // Formate la date si elle existe
      "Créer par": item.create_by,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Prestations");

    XLSX.writeFile(workbook, "export_articles_achat.xlsx");
  };

  const columns = [
    {
      title: "Code",
      dataIndex: "code_art",
      key: "code_art",
      className: "small-cell",
      align:"center",
      ellipsis: true,
      width: "10%",
      render: (text) => (
        <strong>{text}</strong>
      ),
    },
    {
      title: "Designation",
      dataIndex: "designation_article",
      key: "designation_article",
      className: "small-cell",
      ellipsis: true,
      width: "30%",
    },
    {
      title: "prix unitaire",
      dataIndex: "prix_unitaire",
      key: "prix_unitaire",
      className: "small-cell",
      ellipsis: true,
      width: "15%",
      align: "center",
    },
    {
      title: "compte",
      dataIndex: "compte_rattache",
      key: "compte_rattache",
      className: "small-cell",
      ellipsis: true,
      width: "10%",
      align: "center",
    },
    {
      title: "Créer le",
      dataIndex: "datecreation",
      key: "datecreation",
      className: "small-cell",
      ellipsis: true,
      width: "10%",
      align: "center",
      render: (text) => {
        if (text) {
          moment.locale("fr");
          return (
            <div style={{ whiteSpace: "nowrap" }}>
              {moment(text).format("DD-MM-YYYY")}
            </div>
          );
        } else {
          return null; // Retourne null si la date est null pour afficher une cellule vide
        }
      },
    },
    {
      title: "Créer par",
      dataIndex: "create_by",
      key: "create_by",
      className: "small-cell",
       render: (text) => text ? moment(text).format("DD/MM/YYYY") : "",
      ellipsis: true,
      width: "10%",
    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      key: "action",
      className: "small-cell",
      align: "center",
      // className: 'custom-action-column'
      ellipsis: true,
      width: "5%",
      render: (text, record) => (
        <Popconfirm
          title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
          onConfirm={() => handleDelete(record.code_art)}
          okText="Oui"
          cancelText="Non"
        >
          <Button
            danger
            style={{ border: "none", fontSize: "16px" }}
            icon={<DeleteFilled />}
          ></Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xs={24} xl={18}>
          <Card>
            <Row gutter={[16, 16]}>
              <Col
                span={9}
                style={{
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                {/*  barre de recherche */}
                <Input
                  className="search-input-highlight"
                  placeholder="Rechercher..."
                  allowClear
                  prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
                  style={{ width: 250 }}
                  onChange={(e) => handleSearch(e.target.value)}
                  onPressEnter={(e) => handleSearch(e.target.value)}
                />
              </Col>
              <Col
                span={15}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                {/* Vos boutons d'export et d'actualisation */}
                <Space>
                  <Button
                    className="buttonExport"
                    icon={<ExportOutlined />}
                    onClick={handleExport}
                  >
                    Export
                  </Button>
                  <Button  className="buttonRefresh"  onClick={handleResetAll} icon={<SyncOutlined />}>
                    Actualiser
                  </Button>
                </Space>
              </Col>
            </Row>
          </Card>

          <Table
            className="custom-header1-table compact-rows-table"
          //  className="custom-header1-table"
          showSorterTooltip={false}
            bordered
            /* size='small' */ columns={columns}
            dataSource={filteredData}
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
            })}
            loading={loading}


          />
        </Col>

        <Col xs={24} xl={6}>
          {showCreateForm ? (
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title level={4} style={{ margin: 0,marginLeft: "15px", color: "#ffffff" }}>
                    {" "}
                    Nouvelle Article
                  </Title>
                </div>
              }
            >
              <Form layout="vertical">
                <Form.Item label="Designation de l'article">
                  <Input
                    placeholder="Designation..."
                    //value={newPrestation.designation_article}
                    onChange={(e) =>
                      setNewPrestation({
                        ...newPrestation,
                        designation_article: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item label="Prix Unitaire">
                  <Input
                    placeholder="prix..."
                    value={newPrestation.prix_unitaire} // Ajouter la valeur par défaut ici
                    onChange={(e) =>
                      setNewPrestation({
                        ...newPrestation,
                        prix_unitaire: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item label="Compte rattaché">
                  <Select
                    placeholder="Sélectionner un compte"
                    onChange={(value) =>
                      setNewPrestation({
                        ...newPrestation,
                        compte_rattache: value,
                      })
                    }
                  >
                    {planCompta.map((compte) => (
                      <Select.Option
                        key={compte.id}
                        value={`${compte.compte} - ${compte.intitule}`}
                      >
                        {`${compte.compte} - ${compte.intitule}`}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button
                      onClick={() => setShowCreateForm(false)}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Annuler
                    </Button>
                    <Button
                      type="primary"
                      onClick={handleSave}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Enregistrer
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          ) : (
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title level={4} style={{ margin: 0, color: "#ffffff" }}>
                    {" "}
                    Modification Article
                  </Title>
                </div>
              }
            >
              <Form layout="vertical">
                <Form.Item label="Designation de l'article">
                  <Input
                    placeholder="Designation..."
                    value={
                      selectedRowData ? selectedRowData.designation_article : ""
                    }
                    onChange={(e) =>
                      setSelectedRowData({
                        ...selectedRowData,
                        designation_article: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item label="Prix Unitaire">
                  <Input
                    placeholder="prix..."
                    value={selectedRowData ? selectedRowData.prix_unitaire : ""}
                    onChange={(e) =>
                      setSelectedRowData({
                        ...selectedRowData,
                        prix_unitaire: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item label="Compte rattaché">
                  <Select
                    placeholder="Sélectionner un compte"
                    value={
                      selectedRowData
                        ? `${selectedRowData.compte_rattache} - ${
                            planCompta.find(
                              (compte) =>
                                compte.compte ===
                                selectedRowData.compte_rattache
                            )?.intitule
                          }`
                        : ""
                    }
                    onChange={(value) => {
                      const selectedCompte = value.split(" - ")[0];
                      setSelectedRowData({
                        ...selectedRowData,
                        compte_rattache: selectedCompte,
                      });
                    }}
                  >
                    {planCompta.map(
                      (
                        compte // Génère les options du Select à partir de planCompta
                      ) => (
                        <Select.Option
                          key={compte.id}
                          value={`${compte.compte} - ${compte.intitule}`}
                        >
                          {`${compte.compte} - ${compte.intitule}`}{" "}
                          {/* Affichage de chaque option avec le compte et son intitulé */}
                        </Select.Option>
                      )
                    )}
                  </Select>
                </Form.Item>

                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button
                      type="primary"
                      onClick={handleNew}
                      style={{
                        backgroundColor: "transparent",
                        color: "#010f1c",
                        borderColor: "#010f1c",
                      }}
                    >
                      Nouveau
                    </Button>
                    <Button
                      onClick={handleUpdate}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Modifier
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ArticlesAchat;
